var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 35.0961H4.6219C3.6633 35.0938 2.74443 34.6675 2.06586 33.9103C1.3873 33.1531 1.00413 32.1265 1 31.0545V5.59813C1.00207 4.52464 1.38432 3.49578 2.06311 2.7367C2.7419 1.97763 3.66195 1.55016 4.6219 1.54785H26.9791",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6008 5.59863V31.0375C30.6008 32.1125 30.2195 33.1436 29.5404 33.9046C28.8614 34.6656 27.9402 35.0942 26.9789 35.0966H19.9385",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6402 3.55964C31.0722 3.55964 31.4224 3.16798 31.4224 2.68485C31.4224 2.20172 31.0722 1.81006 30.6402 1.81006C30.2081 1.81006 29.8579 2.20172 29.8579 2.68485C29.8579 3.16798 30.2081 3.55964 30.6402 3.55964Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0418 35.0956V24.1695H11.5999V18.9732H15.0418V13.9607C15.0418 12.5686 15.5363 11.2336 16.4166 10.2492C17.2968 9.2649 18.4906 8.71191 19.7354 8.71191H24.609V13.6545H21.0418C20.8882 13.6544 20.736 13.6888 20.5944 13.7556C20.4528 13.8224 20.3246 13.9203 20.2174 14.0434C20.1102 14.1665 20.0262 14.3125 19.9703 14.4725C19.9144 14.6326 19.8877 14.8036 19.8919 14.9754V18.947H24.5855V24.1957H19.8919V35.0956",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bee3173319e0a1daf70ff5fd8c29ac55.svg";
export { ForwardRef as ReactComponent };